import React from 'react';
import propTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { buildUserTypeInfo } from './info';
import { InfoTooltip } from 'lib';
import { userTypes } from '../../helpers/userTypes';
import styles from './styles';

const useStyles = makeStyles(styles);

const UserTypeInfo = ({ type, isScheduleOnly, availabilityEnabled }) => {
  const classes = useStyles();

  const info = buildUserTypeInfo(type, { isScheduleOnly, availabilityEnabled });
  if (!info) return null;

  const content = (
    <>
      {type !== userTypes.admin && <strong>Core Functionality:&nbsp;</strong>}
      <span>{info}</span>
    </>
  );

  return (
    <InfoTooltip
      content={content}
      variant="inline"
      className={classes.icon}
    />
  );
};

UserTypeInfo.propTypes = {
  type: propTypes.string.isRequired,
  isScheduleOnly: propTypes.bool,
  availabilityEnabled: propTypes.bool,
};

export default UserTypeInfo;
